export function formatCount(totalCount:number) {
  if (totalCount >= 2000) {
    return `${Math.floor(totalCount / 1000) * 1000}+`;
  } else {
    return totalCount.toString();
  }
}